
export { strideAccountParser } from "/vercel/path0/node_modules/.pnpm/stridejs@0.12.1/node_modules/stridejs/dist/esm/parser.js"